// import React from 'react';
import Nav from '../../common/Nav';
import Footer from '../../common/Footer';
import BlogComponent from './BlogComponent';
// import blogData from '../../common/blogData.json'
import { Link } from "react-router-dom";
import React, { useState, useEffect } from 'react';
import { ref, onValue } from 'firebase/database';
import { secondaryDatabase } from '../../auth/firebase';
import { blogPosts } from '../../common/data';
import adventure from '../../assets/Adventure vs. Leisure_ Choosing Your Perfect Vacation.png'
import friendlyTrip from '../../assets/Best Budget-Friendly International Trips for Indians.png'
import hiddleTravelDestinations from '../../assets/Hidden Travel Destinations in India You Must Visit.png'


const BlogPage = () => {

    const blogPosts = [
        {
          id: "1",
          slug: "Adventure-vs-Leisure-Choosing-Your-Perfect-Vacation",
          title: "Adventure vs. Leisure_ Choosing Your Perfect Vacation",
          metaDescription: "Explore India's hidden travel gems beyond the crowds! Plan your trip with the Top 10 travel agency in Delhi or the Best travel agency in Delhi for international Tours.",
          thumbnail: adventure,
          content: `India is a land of diverse landscapes, rich history, and breathtaking natural beauty...`, // full blog content
        },
        {
          id: "2",
          slug: "Best-Budget-Friendly-International-Trips-for-Indians",
          title: "Best Budget-Friendly International Trips for Indians",
          metaDescription: "Don’t miss anything on your next international trip. Here’s a comprehensive travel checklist curated by the best travel agency in Delhi.",
          thumbnail: friendlyTrip,
          content: "Coming soon...", // replace with full content
        },
        {
          id: "3",
          slug: "Hidden-Travel-Destinations-in-India-You-Must-Visit",
          title: "Hidden Travel Destinations in India You Must Visit",
          metaDescription: "Plan a dreamy honeymoon without breaking the bank! Discover budget destinations with Pravasa.in’s expert travel planners.",
          thumbnail: hiddleTravelDestinations,
          content: "Coming soon...", // replace with full content
        }
      ];
    // const blogPosts = [
    //     {
    //         title: "Adventure vs. Leisure: Choosing Your Perfect Vacation",
    //         metaDescription: "Adventure or leisure? Discover the perfect vacation for you. Plan stress-free with a registered travel agent in Delhi. Find the best travel agency for international tours.",
    //         imageUrl: "https://images.unsplash.com/photo-1506929562872-bb421503ef21?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80",
    //         content: [
    //           "Planning a vacation comes with one big question—should you go for an adrenaline-filled adventure or a relaxing leisure trip? Both types of vacations offer unique experiences, catering to different personalities, moods, and travel goals. Whether you dream of hiking rugged mountains or unwinding by the beach, your choice will shape your travel memories.",
    //           "The Thrill of Adventure Travel Adventure travel is for those who seek excitement and love to push their limits. It often includes physically demanding activities such as trekking, scuba diving, paragliding, or wildlife safaris. These experiences provide an unmatched sense of accomplishment and an opportunity to explore breathtaking landscapes.",
    //           "Why Choose an Adventure Vacation? Adrenaline Rush – Activities like skydiving, white-water rafting, and bungee jumping create unforgettable moments. Personal Growth – Overcoming challenges, whether climbing a peak or diving into the ocean, builds resilience and confidence. Unique Cultural Exposure – Adventure trips often lead to remote locations, offering deeper insights into local traditions and lifestyles.",
    //           "Popular Adventure Destinations Rishikesh, India – Perfect for river rafting, cliff jumping, and bungee jumping. Leh-Ladakh – Offers thrilling road trips, treks, and biking adventures. Switzerland – Known for skiing, paragliding, and hiking in the Alps. New Zealand – A paradise for extreme sports like skydiving and canyoning.",
    //           "The Charm of Leisure Travel Leisure vacations are designed for relaxation and rejuvenation. These trips focus on comfort, slow-paced exploration, and unwinding at scenic locations. Whether it's a beach retreat, a cultural city tour, or a luxury resort stay, leisure travel is all about indulgence.",
    //           "Why Choose a Leisure Vacation? Stress-Free Experience – No rigid itineraries, just peaceful sightseeing and relaxation. Rejuvenation – Ideal for unwinding at spas, beaches, or cozy mountain resorts. Quality Time – Perfect for family vacations, romantic getaways, or solo retreats.",
    //           "Popular Leisure Destinations Maldives – Overwater villas, white sandy beaches, and clear blue waters. Paris, France – A dream city with art, history, and luxury shopping. Goa, India – Laid-back beaches, delicious seafood, and vibrant nightlife. Bali, Indonesia – Serene landscapes, yoga retreats, and cultural sites.",
    //           "Finding the Right Balance Sometimes, the best vacation combines elements of both adventure and leisure. Destinations like Thailand, Spain, and Australia offer thrilling activities alongside relaxing experiences. Choosing a balanced itinerary allows you to explore exciting adventures while enjoying moments of peace.",
    //           "Planning Your Ideal Trip with Expert Help Choosing between an adventure and leisure vacation can be overwhelming, but a professional travel agency simplifies the process. If you're searching for the Top 10 travel agency in Delhi or need recommendations from the Delhi travel agency list, it's essential to pick one that understands your travel needs.",
    //           "A registered travel agent in Delhi, such as Pravasa.in, ensures a hassle-free experience by offering customized itineraries, the best deals, and seamless booking services. Whether you need a travel agency in Delhi near me for last-minute planning or the best travel agency in Delhi, expert guidance helps make your dream vacation a reality.",
    //           "Conclusion Adventure and leisure travel cater to different preferences, but both offer enriching experiences. While thrill-seekers enjoy heart-pounding activities, relaxation lovers cherish peaceful getaways. With the right travel partner like Pravasa.in, you can craft a vacation that perfectly suits your style—whether it's an action-packed journey or a tranquil retreat."
    //         ]
    //       }
    //     {
    //         title: 'Travel Tips for First-Time Travelers',
    //         excerpt: 'Essential tips to make your first travel experience unforgettable.',
    //         author: 'Suresh Malhotra',
    //         date: 'February 28, 2024',
    //         image: 'https://via.placeholder.com/400',
    //         link: '#'
    //     },
    //     {
    //         title: 'A Guide to Sustainable Travel',
    //         excerpt: 'Learn how to travel responsibly while enjoying your adventures.',
    //         author: 'Abhinav Sharma',
    //         date: 'January 15, 2024',
    //         image: 'https://via.placeholder.com/400',
    //         link: '#'
    //     },
    //     // Add more posts as needed
    // ];
    // const videoSamples = [
    //     {
    //         title: 'Exploring the Alps',
    //         videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    //         description: 'A breathtaking journey through the majestic Alps.',
    //     },
    //     {
    //         title: 'Adventures in Bali',
    //         videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    //         description: 'Experience the vibrant culture and stunning landscapes of Bali.',
    //     },
    // ];
    // const [posts, setPosts] = useState([]);
    // const [loading, setLoading] = useState(true);
    // const [error, setError] = useState(null);
  
    // useEffect(() => {
    //   try {
    //     // Verify secondaryDatabase is initialized
    //     if (!secondaryDatabase) {
    //       throw new Error("Firebase database not initialized");
    //     }
  
    //     const blogRef = ref(secondaryDatabase, 'vacation_guide');
        
    //     const unsubscribe = onValue(blogRef, (snapshot) => {
    //       const data = snapshot.val();
    //       if (data) {
    //         const postsArray = Object.keys(data).map(key => ({
    //           id: key,
    //           ...data[key]
    //         }));
    //         setPosts(postsArray);
    //         console.log("blog firebase Data : :::::: :>>>", posts);
    //       }
    //       console.log("blog firebase Data : :::::: :>>>", posts);
    //       setLoading(false);
    //     }, (error) => {
    //       setError(error.message);
    //       setLoading(false);
    //     });
  
    //     return () => unsubscribe();
    //   } catch (err) {
    //     setError(err.message);
    //     setLoading(false);
    //   }
    // }, []);
  
    // if (loading) return <div>Loading...</div>;
    // if (error) return <div>Error: {error}</div>;
    const imageUrls =[
        {
            id:1,
            image:'src/assets/Adventure vs. Leisure_ Choosing Your Perfect Vacation.png'
        }
    ]
    return (
        <div className="bg-gray-100 ">
            <div className='p-6'>
                <Nav />
            </div>
            <div className='my-8 md:mt-48 md:mb-48'>
            <div className="p-4 grid grid-cols-1 md:grid-cols-3 gap-6">
      {blogPosts.map((post) => (
        <div key={post.id} className="rounded-2xl shadow-lg overflow-hidden">
          <img src={post.thumbnail} alt={post.title} className="w-full h-48 object-cover" />
          <div className="p-4">
            <h2 className="text-xl font-semibold">{post.title}</h2>
            <p className="text-sm text-gray-600">{post.metaDescription.slice(0, 100)}...</p>
            <Link
              to={`/blog/${post.slug}`}
              className="inline-block mt-2 text-blue-600 font-medium hover:underline"
            >
              Read More →
            </Link>
          </div>
        </div>
      ))}
    </div>
            </div>
           
            <Footer/>
        </div>
    );
};

export default BlogPage;
